import axios from "axios";
import { DueDiligenceType } from "../pages/types/KycDocType";

export const createDueDiligenceDoc = (
  dueDiligenceDetails: DueDiligenceType,
  sessionId: string | null
) => {
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/create/one/customer.due_diligence_document`,
      {
        params: {
          context: {},
          data: dueDiligenceDetails,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
